import React, { useContext } from "react";
import { NavPage } from "../../services/NavService";
import { EditorNav } from "../EditorNav/EditorNav";
import { TopNav } from "../TopNav/TopNav";
import "../../style/editor.scss";
import "./DimensionsEditor.scss";
import { CabinetWidthSetter } from "./CabinetWidthSetter";
import { CabinetHeightSetter } from "./CabinetHeightSetter";
import { CabinetDepthSetter } from "./CabinetDepthSetter";
import { EditorContext } from "../EditorCommon/EditorContext";
import { CabinetPositionSetter } from "./CabinetPositionSetter";
import { OverlayTrigger, Popover, PopoverContent, PopoverTitle } from "react-bootstrap";
import { CabinetPosition } from "../../services/WebApiClient";



export function DimensionsEditor(props: {}) {

    const ec = useContext(EditorContext);

    const sidePanelOverlay = (
        <Popover id={"popover-side-panel"} >
            <PopoverTitle>
                {ec.translator("interior side panel help title", "Anslag")}
            </PopoverTitle>
            <PopoverContent style={{ whiteSpace: "pre-line" }}>
                {ec.translator(
                    "interior side panel help text",
                    "Anslagslisten bruges hvis væggen er skæv eller ujævn.\nKan med fordel bruges ved murstensvæg for at skåne kanten på døren.")}
            </PopoverContent>
        </Popover>
    );

    return (
        <div className="editor dimensions-editor">
            <TopNav header={ec.translator(NavPage.Dimensions)} />

            <div className="main-editor">
                <CabinetPositionSetter />

                <div className="cabinet-dimensions-setter">
                    <div className="form-group">
                        <label htmlFor="cabinet-width-setter-input">
                            {ec.translator("dimensions width text", "Bredde:")}
                        </label>
                        <div className="input-group">
                            <CabinetWidthSetter
                                id="cabinet-width-setter-input"
                                className="form-control"
                            />
                            <div className="input-group-append">
                                <div className="input-group-text">mm</div>
                            </div>
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="cabinet-height-setter-input">
                            {ec.translator("dimensions height text", "Højde:")}
                        </label>
                        <div className="input-group">
                            <CabinetHeightSetter
                                id="cabinet-height-setter-input"
                                className="form-control"
                            />
                            <div className="input-group-append">
                                <div className="input-group-text">mm</div>
                            </div>
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="cabinet-depth-setter-select">
                            {ec.translator("dimensions depth text", "Dybde:")}
                        </label>
                        <div className="input-group">
                            <CabinetDepthSetter
                                id="cabinet-depth-setter-select"
                                className="form-control"
                            />
                            <div className="input-group-append">
                                <div className="input-group-text">mm</div>
                            </div>
                        </div>
                    </div>

                    <div className="form-group">
                        <OverlayTrigger trigger={["hover", "focus"]}
                            overlay={sidePanelOverlay}
                            placement="left"
                        >
                                <ul className="list-group">
                                    <li className={classes({
                                        "list-group-item": true,
                                        "side-panel-option": true,
                                        "active": ec.cabinet.sidePanel === true,
                                        "disabled": ec.cabinet.position === CabinetPosition.FreeStanding
                                    })}
                                        onClick={() => ec.cabinetService.setSidePanel(true)}
                                        tabIndex={0}
                                    >
                                        {ec.translator("dimensions sidepanel on", "Anslag")}
                                    </li>

                                    <li className={classes({
                                        "list-group-item": true,
                                        "side-panel-option": true,
                                        "active": ec.cabinet.sidePanel === false
                                    })}
                                        onClick={() => ec.cabinetService.setSidePanel(false)}
                                        tabIndex={0}
                                    >
                                        {ec.translator("dimensions sidepanel off", "Ingen Anslag")}
                                    </li>
                                </ul>
                        </OverlayTrigger>
                    </div>
                </div>
            </div>

            <EditorNav currentPage={NavPage.Dimensions} />
        </div>
    );
}

function classes(classNames: { [className: string]: any }): string {
    const activeClasses: string[] = [];
    for (let className in classNames) {
        const isActive = classNames[className];
        if (isActive) {
            activeClasses.push(className);
        }
    }
    const result = activeClasses.join(" ");
    return result;
}
